import * as actionTypes from './../actions/appAction';

const initialState = {
  displayFeedingGuidelines: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SHOW_FEEDING_GUIDELINES:
      return {
        ...state,
        displayFeedingGuidelines: true,
      };
    default:
      return state;
  }
};

export default reducer;
